import React from "react";
import Story from "../../layouts/Story";
import ClusterViz from "./charts/ClusterViz";
import RingChart from "./charts/RingChart";
const copy = require(`./copy/${process.env.REACT_APP_LANG}`);

const StoryThree = () => {
  const additionalComponents = {
    clusterViz: ClusterViz,
    ringChart: (props) => <RingChart copy={copy.ring} {...props} />,
  };

  return <Story {...copy} additionalComponents={additionalComponents} />;
};

export default StoryThree;
